import "phoenix_html";

// === Bootstrap Components (Tree-shaken) ===
import Collapse from "bootstrap/js/dist/collapse";
import Dropdown from "bootstrap/js/dist/dropdown";
import Modal from "bootstrap/js/dist/modal";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import Tab from "bootstrap/js/dist/tab";
import Tooltip from "bootstrap/js/dist/tooltip";

window.bootstrap = { Collapse, Dropdown, Modal, Offcanvas, Tab, Tooltip };

// === Core Initializers ===
import "./initializers/alpine-initializer";
import "./initializers/turbo-initializer";
import "./initializers/showmore-initializer";
import "./initializers/alert-initializer";
import "./initializers/tooltips-initializer";
import "./initializers/popover-initializer";
import "./initializers/bootstrap-components-initializer";
import "./initializers/youtube-initializer";

// === Third-party Service Integrations ===
import "./initializers/calendly-initializer";

// === Analytics & Tracking ===
import "./frontend/simple-analytics-helper";
import "./frontend/mailchimp-utm-helper";

// === UI Components ===
import "./frontend/navbar";
import "./frontend/bottom-bar";
import "./frontend/back-to-top";
import "./frontend/tabs";
import "./frontend/smooth-scrolling";
import "./frontend/content-navigation";
import "./frontend/mouse-cursor-gradient-tracking";
import "./frontend/client-references";

// === Lazy-loaded Features (Only load when elements exist) ===
import "./frontend/carousels"; // ~70KB - Swiper only loads when carousel exists
// import "./frontend/highlightjs"; // ~15-25KB - highlight.js only loads when <pre><code> exists

// === Modals ===
import "./frontend/image-modal";
import "./frontend/trainer-modal";

// === Page-specific Features ===
import "./frontend/course-subscription";
import "./frontend/course-share";
import "./frontend/track-booking";

// === Utility Components ===
import "./components/lazy-load";
import "./components/prevent-double-clicks";
import "./components/color-mode-switcher";
import "./initializers/darkmode-initializer";

// === Form Validation ===
import "./frontend/email-validator";

// === Event Booking (only loads on booking pages) ===
import "./frontend/event-booking-price-updater";
import "./frontend/event-booking-payment";
import "./frontend/event-booking-hints";
import "./components/countdown-timer";
import "./components/attendee-stepper";

// === Search ===
import "./frontend/search";
import "./frontend/search-spinner";
import "./frontend/home-search-placeholder";

// === Tracking Helpers ===
import "./frontend/fbclid-helper";
import "./frontend/gclid-helper";
import "./frontend/twclid-helper";

// === Event Views ===
import "./frontend/event-view-switcher";
import "./frontend/event-calendar";

// === Search Toggle ===
import "./components/search-toggle";
